export default {
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100vw',
    position: 'relative',
  },
  fullWidth: {
    width: '100%',
  },
  logoContainer: {
    width: ['15%', '15%', '10%'],
    display: ['none', 'flex'],
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'absolute',
    top: ['2%', '15%', '40px'],
    left: ['40%', '45%'],
    zIndex: 2,
  },
  logoSecondaryContainer: {
    width: ['15%', '25%', '10%'],
    display: ['none', 'flex'],
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'absolute',
    top: ['2%', '15%', '40px'],
    zIndex: 5,
  },
  menuContainer: {
    width: '100%',
    display: ['none', 'flex'],
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'absolute',
    top: '40px',
    zIndex: 2,
  },
  headerImage: {
    width: '100vw',
    minHeight: ['270px', '100%'],
    maxHeight: ['0px', '400px'],
    objectFit: 'cover',
  },
  imageContainer: {
    display: 'flex',
    backgroundColor: 'tmBlue',
    height: '100%',
    position: 'relative',
  },

  overlay: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: ['100%', '100%', '40%'],
    opacity: [0.7, 0.6],
    background: 'linear-gradient(black, transparent)',
  },

  blueOverlay: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    opacity: 0.8,
    background: 'linear-gradient(#0F204B, #0F204B)',
  },

  titleContainer: {
    position: 'absolute',
    top: ['60%', '53%'],
    left: ['0', '55px'],
    padding: '5px 10px 5px 30px',
    display: 'flex',
    flexDirection: 'column',
  },

  title: {
    color: ['tmWhite'],
    fontFamily: 'bold',
    textTransform: 'uppercase',
    fontSize: ['26px', '57px'],
  },
  bottomTitle: {
    color: ['tmWhite'],
    fontFamily: 'bold',
    textTransform: 'uppercase',
    fontSize: ['26px', '57px'],
    lineHeight: ['26px', '68px'],
  },
}
